module.exports = new __parcel__URL__("devdotto.c5600637.svg").toString();